import React from 'react';
import styled, { css } from 'styled-components';
import { Button } from 'fpay-ui';
import { Link } from 'react-router-dom';

const Layout = styled.div(
  () => css`
    display: flex;
    border-radius: 6px;
    width: 600px;
    min-height: 120px;
    background: #ffff;
    margin-bottom: 16px;
    padding: 24px;
    ${({ theme }) => theme.newBreakpoint('md')} {
      width: 600px;
    }
    ${({ theme }) => theme.newBreakpoint('sm')} {
      padding-left: 0;
      padding-right: 0;
      width: 100%;
    }
  `
);

const StyledCardInfoLeftSide = styled.div(
  () => css`
    padding-right: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ theme }) => theme.newBreakpoint('sm')} {
      padding: 0 16px 0 16px;
    }
  `
);

const StyledCardInfoRightSide = styled.div(
  () => css`
    border-left: 1px solid #c2c2c2;
    padding-left: 24px;
    ${(props) =>
      props.haveButton && {
        display: 'flex',
        flexDirection: 'row',
      }});

    ${({ theme }) => theme.newBreakpoint('sm')} {
      padding-left: 16px;
      ${(props) =>
        props.haveButton && {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
        }});
    }
  `
);

const StyledCardInfoNumber = styled.div(
  () => css`
    background: #0071ce;
    border-radius: 15px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: var(--font_main);
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0;
    text-align: center;
    color: #ffffff;
  `
);

const StyledCardInfoTitle = styled.div(
  ({ theme }) => css`
    ${theme.textTypes['Title-w700']}
    font-size: 16px;
    text-align: left;
  `
);

const StyledCardInfoDescription = styled.div(
  ({ theme }) => css`
    ${theme.textTypes['Description-w700']}
    font-size: 14px;
    text-align: left;
  `
);

const StyledOkButton = styled.div(
  () => css`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    gap: 10px;
    ${({ theme }) => theme.newBreakpoint('sm')} {
      margin-top: 8px;
    }
    button {
      width: 184px;
      height: 40px;
      font-family: var(--font_main);
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: -0.02em;
      text-align: center;
    }
  `
);

export const BlockScreenCard = ({
  number,
  title,
  firstDescription,
  SecondDescription,
  textToLink,
  urlToGo,
  buttonText = '',
  onClick,
}) => (
  <Layout>
    <StyledCardInfoLeftSide>
      <StyledCardInfoNumber>{number}</StyledCardInfoNumber>
    </StyledCardInfoLeftSide>
    <StyledCardInfoRightSide haveButton>
      <div>
        <StyledCardInfoTitle>{title}</StyledCardInfoTitle>
        {typeof textToLink === 'undefined' && typeof urlToGo === 'undefined' ? (
          <StyledCardInfoDescription>{firstDescription}</StyledCardInfoDescription>
        ) : (
          <StyledCardInfoDescription>
            {firstDescription}
            <Link to={urlToGo}>{textToLink}</Link>
            {SecondDescription}
          </StyledCardInfoDescription>
        )}
      </div>
      {buttonText.length > 0 && (
        <StyledOkButton>
          <Button size="medium" onClick={() => onClick()}>
            {buttonText}
          </Button>
        </StyledOkButton>
      )}
    </StyledCardInfoRightSide>
  </Layout>
);

export default BlockScreenCard;
